export const Icon = ({ name, style }) => {
  return (
    <svg class={`icon ${style ? style : ""}`}>
      <use href={`#icon-${name}`} />
    </svg>
  )
}
